import Model from "~/models/_Model";

export default class Staff extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/substitute";
  }

  // Set the resource route of the model
  resource() {
    return "attendance-staff";
  }

  primaryKey() {
    return "STAFF_ID";
  }

  relations() {
    return {
      //fails: Fail
    };
  }
}
